/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Attendance_TitleInputs */

const en_interview_attendance_title = /** @type {(inputs: Interview_Attendance_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm interview`)
};

const de_interview_attendance_title = /** @type {(inputs: Interview_Attendance_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gespräch bestätigen`)
};

/**
* | output |
* | --- |
* | "Confirm interview" |
*
* @param {Interview_Attendance_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const interview_attendance_title = /** @type {((inputs?: Interview_Attendance_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Attendance_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_attendance_title(inputs)
	return en_interview_attendance_title(inputs)
});